import { render, staticRenderFns } from "./BankingInfo.vue?vue&type=template&id=8a44a3fa&scoped=true"
import script from "./BankingInfo.vue?vue&type=script&lang=js"
export * from "./BankingInfo.vue?vue&type=script&lang=js"
import style0 from "./BankingInfo.vue?vue&type=style&index=0&id=8a44a3fa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8a44a3fa",
  null
  
)

export default component.exports